// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"map_iconSync__2tfw7","fa-spin":"map_fa-spin__FIK4f"};